/* blocks */
import CustomerLogo from '@/cmp/organism/CustomerLogo/CustomerLogo'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'
import PageHero from '@/cmp/organism/PageHero/PageHero'
import ValueOutcomes from '@/cmp/organism/ValueOutcomes/ValueOutcomes'
import ScrollFeatures from '@/cmp/organism/Feature/ScrollFeatures'
import Ecosystem from '@/cmp/organism/Ecosystem/Ecosystem'
import MoreCaseStudies from '../CaseStudy/components/MoreCaseStudies/MoreCaseStudies'
import FAQNew from '@/cmp/organism/FAQNew/FAQNew'

/* utils */
import { FeaturePageAttributes } from '@/utils/queries/features'

/* styles */
import styles from './_.module.css'

interface Props {
  data: FeaturePageAttributes
}

function Features({ data }: Props): JSX.Element {
  return (
    <>
      <PageHero
        class={styles.feature_hero}
        primaryHeadline={data.hero.title}
        subText={data.hero.description}
        primaryCta={data.hero.primaryCta}
        secondaryCta={data.hero.secondaryCta}
        footNote={data.hero.footnote}
        image={data.hero.image?.data?.attributes}
      />

      {data.brands.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brands.title}
          brands={data.brands.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
        />
      ) : null}

      {data.valueOutcomeList.length > 0 ? (
        <ValueOutcomes
          class={styles.feature_valueoutcome}
          layout="descriptive"
          theme="dark"
          title={data.valueOutcomeTitle}
          list={data.valueOutcomeList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.featureListScroll.length > 0 ? (
        <ScrollFeatures
          class={styles.features_feature_list_scroll}
          layout="content-left"
          title={data.featureTitle}
          list={data.featureListScroll.map(i => ({
            id: i.id,
            link: i.link,
            bgColor: i.color,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.contentEcosystem.multimedia?.media?.data?.attributes ? (
        <Ecosystem
          title={data.contentEcosystem.title ?? ''}
          description={data.contentEcosystem.description ?? ''}
          image={data.contentEcosystem.multimedia.media.data.attributes}
        />
      ) : null}

      {data.moreCaseStudies.data.length > 0 ? (
        <MoreCaseStudies
          title={data.caseStudyTitle}
          data={data.moreCaseStudies.data}
          isHomePage={true}
          showViewMore={false}
        />
      ) : null}

      {data.faqs.length > 0 ? (
        <FAQNew title="Frequently asked questions" list={data.faqs} />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          mode="full_width"
        />
      ) : null}
    </>
  )
}

export default Features
